import { Component, OnInit, Input } from '@angular/core';
import { PopoverService } from '@services/popover/popover.service';
import { PopupObservationService } from '@services/observationDetail/popup-observation.service';

@Component({
  selector: 'app-message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss'],
})
export class MessagePopupComponent implements OnInit {
  @Input() userObject: any;
  @Input() msgType: string;
  public textMessage = '';

  constructor(private popoverService: PopoverService,
              private popOps: PopupObservationService,
  ) {
  }

  ngOnInit() {
  }

  public async close(): Promise<void> {
    await this.popoverService.safeDismiss();
  }

  public async sendMessage(): Promise<void> {
    await this.popoverService.safeDismiss();
    const requestObject: any = {
      cmd: 'addMessage',
      type: 'message',
      message: this.textMessage,
    };
    if (this.userObject.team) {
      requestObject.groups = [this.userObject.userID];
    } else {
      requestObject.users = [this.userObject.userID];
    }
    this.popOps.sendMessage(requestObject);
  }

}
